import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@/types';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  locale: 'it' | 'en';
  setUser: (user: User | null) => void;
  setLocale: (locale: 'it' | 'en') => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      locale: 'it',
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      setLocale: (locale) => set({ locale }),
      logout: () => set({ user: null, isAuthenticated: false }),
    }),
    {
      name: 'pdf-inspector-auth',
      // Only persist non-sensitive data
      partialize: (state) => ({ 
        user: state.user, 
        isAuthenticated: state.isAuthenticated,
        locale: state.locale 
      }),
    },
  ),
);
